module.exports = __webpack_public_path__ + "images/3b943556dd62bbd521db2d7f50910455-IMG_5448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/IMG_5448.jpg
// module id = ./src/assets/images/slides/home/IMG_5448.jpg
// module chunks = 0